import { render, staticRenderFns } from "./AssignmentBannerDialog.vue?vue&type=template&id=4d6668a0&scoped=true&"
import script from "./AssignmentBannerDialog.vue?vue&type=script&lang=js&"
export * from "./AssignmentBannerDialog.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentBannerDialog.vue?vue&type=style&index=0&id=4d6668a0&scoped=true&lang=scss&"
import style1 from "./AssignmentBannerDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6668a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle,VRow})
